import { areaConstants } from '../../_constants';
import { areaServices } from '../../_services';
import { alertActions, confirmPromptActions, userActions, } from '../index';

export const areaActions = {
    getAreas,
    getAreaById,
    createArea,
    updateArea,
    deleteAreas,
    activation,
    getActiveAreas,
    getActiveAreasWithBranch,
    getAreasWithBranchLoad,
    areaReset,
};
function areaReset() { return { type: areaConstants.AREA_RESET } }

function areaFetching() { return { type: areaConstants.AREA_FETCHING } }
function areaFetched() { return { type: areaConstants.AREA_FETCHED } }

function areaSubmitting() { return { type: areaConstants.AREA_SUBMITTING } }
function areaSubmitted() { return { type: areaConstants.AREA_SUBMITTED } }

function getAreas(skip, take, filter, search) {
    return dispatch => {
        dispatch(areaFetching());
        dispatch(userActions.allowLeavePage());
        areaServices.getAreas(skip, take, filter, search)
            .then(
                areas => {
                    if (areas.length > 0) {
                        dispatch(success(areas));
                        dispatch(areaFetched());
                    } else {
                        dispatch(areaFetched());
                        dispatch(alertActions.warning('No more data to load'))
                    }
                },
                error => {
                    dispatch(areaFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(areas) { return { type: areaConstants.GET_AREAS, areas } }
}
function getAreaById(id) {
    return dispatch => {
        dispatch(areaFetching());
        dispatch(userActions.allowLeavePage());
        areaServices.getAreaById(id)
            .then(
                area => {
                    dispatch(success(area));
                    dispatch(areaFetched());
                },
                error => {
                    dispatch(areaFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(area) { return { type: areaConstants.GET_AREA_BY_ID, area } }
}
function createArea(payload) {
    return dispatch => {
        dispatch(areaSubmitting());
        dispatch(userActions.notallowLeavePage());
        areaServices.createArea(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(areaSubmitted());
                    dispatch(alertActions.success('Area added successfully'))
                    window.location.href = '/master_data/areas';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(areaSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function updateArea(payload, id) {
    return dispatch => {
        dispatch(areaSubmitting());
        dispatch(userActions.notallowLeavePage());
        areaServices.updateArea(payload, id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(areaSubmitted());
                    dispatch(alertActions.success('Area updated successfully'))
                    window.location.href = '/master_data/areas';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(areaSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}
function deleteAreas(id, type, take) {
    return dispatch => {
        dispatch(areaFetching());
        dispatch(userActions.notallowLeavePage());
        areaServices.deleteAreas(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(areaFetched());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Areas deleted successfully'));
                    switch (type) {
                        case "specific":
                            window.location.href = '/master_data/areas';
                            break;
                        default:
                            dispatch(getAreas(0, take));
                            break;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(areaFetched());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                    switch (type) {
                        case "specific":
                            dispatch(getAreaById(id));
                            break;
                        default:
                            dispatch(getAreas(0, take));
                            break;
                    }
                }
            );
    };
}
function activation(id, isActive) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        areaServices.activation(id, isActive)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getAreaById(id));
                    dispatch(alertActions.success(isActive ? 'Area activated successfully' : 'Area deactivated successfully'))
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(areaFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}
function getActiveAreas() {
    return dispatch => {
        areaServices.getActiveAreas()
            .then(
                activeAreas => dispatch(success(activeAreas)),
                error => dispatch(alertActions.error(error.toString()))
            );
    };
    function success(activeAreas) { return { type: areaConstants.GET_ACTIVE_AREAS, activeAreas } }
}
function getActiveAreasWithBranch(branchCode) {
    return dispatch => {
        areaServices.getActiveAreasWithBranch(branchCode)
            .then(
                areasBranch => dispatch(success(areasBranch)),
                error => dispatch(alertActions.error(error.toString()))
            );
    };
    function success(areasBranch) { return { type: areaConstants.GET_ACTIVE_AREAS_WITH_BRANCH, areasBranch } }
}
function getAreasWithBranchLoad(skip, take, branchCode, search) {
    return dispatch => {
        dispatch(areaFetching());
        areaServices.getOriginDestinationAreasLoad(skip, take, branchCode, search)
            .then(
                areas => {
                    if (areas.length > 0) {
                        dispatch(success(areas));
                        dispatch(areaFetched());
                    } else {
                        dispatch(areaFetched());
                        dispatch(alertActions.warning('No more data to load'))
                    }
                },
                error => {
                    dispatch(areaFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(areas) { return { type: areaConstants.GET_AREAS, areas } }
}